<script>
    import GLOBAL_CUSTOM from '@/components/customInfo/Global_qingzhu.vue'
    // import GLOBAL_CUSTOM from '@/components/customInfo/Global_kw.vue'
    // import GLOBAL_CUSTOM from '@/components/customInfo/Global_huizhong.vue'
    // import GLOBAL_CUSTOM from '@/components/customInfo/Global_huidu_it.vue'
    
    const projectName = GLOBAL_CUSTOM.projectName;//"qcbl_edus_auto";   //edus_auto  online  kw_plat hdgj   文件上传用此名称
    const vueProjectName = GLOBAL_CUSTOM.vueProjectName;//qcbl_edus_auto  vue_kw_plat test_kw_plat  online   hdgj_pdf
   const fileServeUrl = GLOBAL_CUSTOM.fileServeUrl;
   const baseURL = GLOBAL_CUSTOM.baseURL;
    const loginBgImage = GLOBAL_CUSTOM.loginBgImage;
    const loginProductName = GLOBAL_CUSTOM.loginProductName;
    const loginSecondProductName = GLOBAL_CUSTOM.loginSecondProductName;
    // const defaultProductName = "可为低代码平台";
    // const defaultProductName = "汇众学员报课平台";
    const defaultProductName = GLOBAL_CUSTOM.defaultProductName;
    const payKey = GLOBAL_CUSTOM.payKey;
    // //百利 考试:87d93bb5a5d24669bab15041d0d11963 社会实践:fJum9FzB9U77fiK8JHuApoFOhPQNLxXF
    // //mch_id:'1490528252', 可为
    const mch_id = GLOBAL_CUSTOM.mch_id;
    //汇众
    const app_id = GLOBAL_CUSTOM.app_id;
    const app_secret = GLOBAL_CUSTOM.app_secret;
    //查询支付状态接口页面设置
    const defaultPayStateInfo = GLOBAL_CUSTOM.defaultPayStateInfo;

    const codePageArr = GLOBAL_CUSTOM.codePageArr;

    //百利学员端 项目id
    // const proId = '56df76b60cf2beac602aaed3/5895423a5b470b3fb83068e7';
    // const proId = '5ee870a2a197a633acc84084/5fc61f07b1648ff6618def39';
    const proId = GLOBAL_CUSTOM.proId;
    //汇众项目
    // const proId = '5919457ca334f19320cc03dd';

    const proIdJson = GLOBAL_CUSTOM.proIdJson;

    // 查看页面的参数数组
    const lookParam = ["tableId","pageId","pageType","listTableId","mainId","callBackType"];
    // 列表页面的参数数组
    const listParam = ["tableId","pageId","pageType","listTableId","mainId","callBackType","initCheckId","dataMaxNum","sourceListMainId","jumpWay","initSearchVal"];
    var fileServeUrlMap = GLOBAL_CUSTOM.fileServeUrlMap;;
    const getFileServeUrl = function(){
      console.log("fileServeUrlMap=====================",fileServeUrlMap,fileServeUrlMap.product17);
      console.log("localStorage.domain_name=====================",localStorage.domain_name,(localStorage.domain_name && localStorage.domain_name != ""),(fileServeUrlMap['product17']));
      if(localStorage.domain_name && localStorage.domain_name != "" && fileServeUrlMap[localStorage.domain_name]) {
        console.log("fileServeUrlMap[localStorage.domain_name]=====================",fileServeUrlMap[localStorage.domain_name]);
        return fileServeUrlMap[localStorage.domain_name];
      } else {
        return fileServeUrl;
      }
    }

    export default {
        projectName,
        vueProjectName,
        fileServeUrl,
        baseURL,
        payKey,
        mch_id,
        app_id,
        app_secret,
        proId,
        proIdJson,
        lookParam,
        listParam,
        codePageArr,
        loginBgImage,
        loginProductName,
        loginSecondProductName,
        defaultProductName,
        defaultPayStateInfo,
        getFileServeUrl
    }
        
</script>